import styled from "styled-components"

const FeesAndFinalPremiumWrapper = styled.div`
  position: sticky !important;
  bottom: 10px !important;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  margin-top: 20px;
`
export default FeesAndFinalPremiumWrapper
